import 'whatwg-fetch';

if (window.NodeList && !NodeList.prototype.forEach) { // I.E. Polyfill, forEach on NodeList
	NodeList.prototype.forEach = Array.prototype.forEach;
}

if (window.HTMLCollection && !HTMLCollection.prototype.forEach) { // I.E. Polyfill, forEach on HTMLCollection
	HTMLCollection.prototype.forEach = Array.prototype.forEach;
}

// Add device-specific classes
if (navigator.userAgent.indexOf('MSIE') > -1 || navigator.userAgent.toLowerCase().indexOf('trident') > -1) {
	document.body.classList.add('is-ie');
}
if (navigator.userAgent.indexOf('Firefox') > -1) {
	document.body.classList.add('is-ff');
}

// Function used internally in module, but also exported
function getDomain(noStaging) {
	let _domain = "";
	if (window.location.host.split('.').length == 4) {
		_domain = window.location.host.split('.')[1] + ".";
	}
	if (window.location.host.split('.').length == 5) {
		_domain = window.location.host.split('.')[1] + "." + window.location.host.split('.')[2] + ".";
	}
	if (noStaging) {
		_domain = _domain.replace('staging.', '');
	}
	return _domain;
}
	
const _u = {
	
	strToDom: function(str) {
		let wrapDiv = document.createElement('div');
		wrapDiv.innerHTML = str;
		return wrapDiv.firstChild;
	},
	
	insertAfter: function(newNode, existingNode) {
		if(typeof existingNode !== 'undefined') {
			existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
		}
		
	},
	
	getSiblings: function(elem) {
		// Setup siblings array and get the first sibling
		let siblings = [];
		let sibling = elem.parentNode.firstChild;

		// Loop through each sibling and push to the array
		while (sibling) {
			if (sibling.nodeType === 1 && sibling !== elem) {
				siblings.push(sibling);
			}
			sibling = sibling.nextSibling
		}

		return siblings;
	},

	qS: function(sel) {
		if (document.querySelectorAll(sel).length <= 1) {
			return document.querySelector(sel);
		} else {
			return document.querySelectorAll(sel);
		}
	},
	
	getUrlParameter: function(sParam) {
		let sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
		}
	},
	
	getDomain: getDomain,
	
	apiGet: function(url, needsCred) {
		let fetchObj = {
			method: 'GET',
			mode: 'cors',
			cache: 'no-cache',
			pragma: 'no-cache',
		};
		if (needsCred) {
			Object.assign(fetchObj, {
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json'
				}
			});
		}
		return fetch(url, fetchObj).then((response) => {
			if (response.ok) {
				return response.json();
			}
		})
	},

	apiPost: function(url, bodyanddata) {
		return fetch(url, bodyanddata).then(response => response.json())
	},
	
	removeElem: function(elem) {
		if (elem != null) {
			elem.parentNode.removeChild(elem);
		}
	},

	timeParse: function(utc) {

		let dateOrig = new Date(utc);
		let currDate = new Date();
		
		let timeZoneOffset = -(dateOrig.getTimezoneOffset()/60); // hours ahead or behind GMT
		let timeZoneAdjusted = Math.round(timeZoneOffset + (timeZoneOffset + 5)); // manipulating timezone to generate date strings consistent with EST instead of localized date, 5 hours for EST, round off non-whole-hour zones	
		let timeZoneHr = String(Math.abs(timeZoneAdjusted));
		if (timeZoneHr.length == 1) { // change 1 digit instances to 2 digit
			timeZoneHr = '0' + timeZoneHr;
		}
		let timeZoneStr = '-0000';
		if (timeZoneAdjusted > 0) {
			timeZoneStr = '+' + timeZoneHr + '00';
		} else {	
			timeZoneStr = '-' + timeZoneHr + '00';
		}
		
		let dateAdjusted = new Date(dateOrig.toString().replace(/ \(.+$/,'').replace(/[+-]\d+$/,timeZoneStr)); // newly generated localized date will have date / time string matching EST		
		let dateArr = dateAdjusted.toString().split(' '); 
		let oneWeekAgo = new Date(currDate.getTime() - 7 * 24 * 60 * 60 * 1000);
		
		let time = Math.round((currDate.getTime() - dateOrig.getTime()) / 60000);
		if(dateAdjusted < oneWeekAgo) {
			time = '';
		} else if (dateOrig.getFullYear() != currDate.getFullYear()) {
			time = dateArr[1] + ' ' + dateArr[2] + ', '+ dateArr[3];
		} else if (time > 59 && time < 1440) {
			time = Math.floor(time / 60) + ' hours ago';
		} else if (time > 1439) {
			time = dateArr[1] + ' ' + dateArr[2] + ', '+ dateArr[3];
		} else {
			time = time + ' minutes ago';
		}
		return time;
	},

	getEventTarget: function(e) {
		e = e || window.event;
		return e.target || e.srcElement;
	},
	
	preLoadImg: function(imgPaths) {
		imgPaths.forEach((path) => {
			let preload = new Image();
			preload.src = 'https://img.' + getDomain() + 'medscapestatic.com' + path;
		});
	},
	
	getIndex: function(elem) {
		let elemArr = new Array();
		elem.parentNode.children.forEach(function(el) {
			elemArr.push(el);
		});
		return elemArr.indexOf(elem);
	},
	
	getClosest: function (elem, selector) {
		// Get the closest matching parent element
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( elem.matches( selector ) ) return elem;
		}
		return null;
	}
	
};

export default _u;
